!function(){"use strict";angular.module("scApp.empresas.anulaciones",[])}();